

import { useCallback, useMemo, useState } from 'react';
import { useUpdateEffect } from 'react-use';


import { hasDataTableData } from '../utils/dataTableData';


import {
  getDataTableFlatRowsNodes,
  getDataTableTreeRowsNodes,
  hasDataTableTreeRowsChildren,
  toggleDataTableFlatRowNodeExpand } from
'../utils/dataTableRow';

export const useDataTableContextValue = ({
  columns,
  rows,
  columnFieldId,
  columnTreeParentFieldId,
  sortOptions,
  infiniteScrollOptions,
  styleType,
  treeStyleType,
  isLoading,
  getRowIndicator,
  getOnRowClick
}) =>
{
  const {
    initial = null,
    isExternal: isExternalSortOption,
    onChange: onSortChangeOption
  } = sortOptions;

  const [sort, setSort] = useState(initial);
  const [flatRowsNodes, setFlatRowsNodes] = useState(
    () => getDataTableFlatRowsNodes(
      rows,
      columnFieldId
    )
  );
  const [treeRowsNodes, setTreeRowsNodes] = useState(
    () => getDataTableTreeRowsNodes(
      flatRowsNodes,
      columnFieldId,
      columnTreeParentFieldId
    )
  );

  const hasData = hasDataTableData(rows);
  const hasTreeData = hasDataTableTreeRowsChildren(treeRowsNodes);
  const hasInfiniteScroll = !!infiniteScrollOptions;

  const onSortChange = useCallback((newSort) => {
    setSort(newSort);

    if (onSortChangeOption) {
      onSortChangeOption(newSort);
    }
  }, [onSortChangeOption]);

  const onRowExpandChange = useCallback(
    (rowId) => setFlatRowsNodes(
      (prevFlatRowsNodes) => toggleDataTableFlatRowNodeExpand(rowId, prevFlatRowsNodes)
    ),
    []
  );

  // When rows changed, reset table state
  useUpdateEffect(() => {
    const newFlatRowsNodes = getDataTableFlatRowsNodes(
      rows,
      columnFieldId
    );
    const newTreeRowsNodes = getDataTableTreeRowsNodes(
      newFlatRowsNodes,
      columnFieldId,
      columnTreeParentFieldId
    );

    setFlatRowsNodes(newFlatRowsNodes);
    setTreeRowsNodes(newTreeRowsNodes);
  }, [rows]);

  return useMemo(() => ({
    sort,
    hasData,
    hasTreeData,
    flatRowsNodes,
    treeRowsNodes,
    styleType,
    treeStyleType,
    isExternalSortOption,
    columns,
    isLoading,
    hasInfiniteScroll,
    infiniteScrollOptions,
    getRowIndicator,
    getOnRowClick,
    onSortChange,
    onRowExpandChange
  }), [
  sort,
  hasData,
  hasTreeData,
  flatRowsNodes,
  treeRowsNodes,
  styleType,
  treeStyleType,
  isExternalSortOption,
  columns,
  isLoading,
  hasInfiniteScroll,
  infiniteScrollOptions,
  getRowIndicator,
  getOnRowClick,
  onSortChange,
  onRowExpandChange]
  );
};